/*
 *   File : offcanvas-detail-view.js
 *   Author : https://evoqins.com
 *   Description : offcanvas-detail-view modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { SectionTitle } from "../Title";

function OffcanvasDetailViewModal(props) {
    return (
        <div className='d-block d-md-none'>
            <button class="btn btn-primary invisible"
                type="button"
                id="offcanvas-modal-btn"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas-modal"
                aria-controls="offcanvas-modal">
                Invisible offcanvas modal
            </button>
            <div class="offcanvas offcanvas-end e-border-radius-top-left-24px"
                data-bs-backdrop="static"
                tabindex="-1"
                id="offcanvas-modal"
                aria-labelledby="offcanvasExampleLabel">
                <div className="d-flex justify-content-between p-3 mb-2">
                    <SectionTitle title={props.title}
                        fontFamily="e-primary-font-inter  e-text-eerie-black mb-2"
                        fontSize="e-font-14" />
                    <img src={require("../../Assets/Images/close-btn.svg").default}
                        draggable={false}
                        width={24}
                        height={24}
                        className='cursor-pointer'
                        data-bs-dismiss="offcanvas"
                        aria-label="close"
                        alt='close btn' />
                </div>
                <div class="offcanvas-body pt-0">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default OffcanvasDetailViewModal;